/**
 * 从数据项中解析封面图 URL。
 * 优先取 thumbnail_url，其次取 image_urls 数组的第一张，最后返回空字符串。
 */
export function resolveThumbnailUrl(data: any): string {
  const imageUrls = Array.isArray(data?.image_urls) ? data.image_urls : [];
  return data?.thumbnail_url || imageUrls[0] || '';
}

/** 指标项配置 */
export interface IMetricItem {
  /** 数据字段名（对应 item 中的 key） */
  key: string;
  /** 指标展示名称 */
  label: string;
  /** 格式化函数，默认使用 DBO_V.reviews */
  format?: (value: any) => string;
  /** 表格列的排序 key（与数据字段 key 不同时使用，默认同 key） */
  columnKey?: string;
}

/** 默认视频指标列表 */
export const DEFAULT_METRICS: IMetricItem[] = [
  { key: 'view_count', label: 'Views' }, 
  { key: 'engagement', label: 'Engagement' },
  { key: 'author_followers', label: 'Followers' },
  { key: 'like_count', label: 'Likes' },
  { key: 'retweet_count', label: 'Shares' },
  { key: 'reply_count', label: 'Comments' },
];
